import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const handleDownloadResume = () => {
    // This would typically link to an actual resume file
    const link = document.createElement('a');
    link.href = '/resume.pdf'; // You'll need to add this file to public folder
    link.download = 'Jacob_Weinrich_Resume.pdf';
    link.click();
  };

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Hi, I'm<br /><span className="highlight">Jacob Weinrich</span>
              </h1>
              <p className="hero-subtitle">
                Software Developer based just outside St. Louis, Missouri
              </p>
              <p className="hero-description">
                Passionate about creating innovative software solutions with expertise in 
                MERN stack, C#, ASP.NET Core MVC, and modern web technologies.
              </p>
              <div className="hero-buttons">
                <Link to="/projects" className="btn btn-primary">
                  View My Work
                </Link>
                <button onClick={handleDownloadResume} className="btn btn-secondary">
                  Download Resume
                </button>
              </div>
            </div>
            <div className="hero-image">
              <div className="profile-placeholder">
                <span>👨‍💻</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Info Section */}
      <section className="quick-info">
        <div className="container">
          <div className="info-grid">
            <div className="info-card">
              <h3>Location</h3>
                              <p>Just outside St. Louis, Missouri</p>
              <p>Central Standard Time</p>
            </div>
            <div className="info-card">
              <h3>Specialties</h3>
              <p>MERN Stack, C#</p>
              <p>ASP.NET Core MVC</p>
            </div>
            <div className="info-card">
              <h3>Experience</h3>
              <p>Full-Stack Development</p>
              <p>DevOps & Project Management</p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Skills Preview */}
      <section className="skills-preview">
        <div className="container">
          <div className="skills-header">
            <h2 className="section-title">Key Skills</h2>
          </div>
          <button 
            onClick={() => {
              window.location.href = '/skills#top';
            }}
            className="btn btn-primary"
          >
            View All Skills
          </button>
          <div className="skills-grid">
            <div className="skill-category">
              <h3>Programming Languages</h3>
              <div className="skill-tags">
                <span className="skill-tag">C#</span>
                <span className="skill-tag">JavaScript</span>
                <span className="skill-tag">HTML/CSS</span>
                <span className="skill-tag">MERN Stack</span>
              </div>
            </div>
            <div className="skill-category">
              <h3>Frameworks & Tools</h3>
              <div className="skill-tags">
                <span className="skill-tag">ASP.NET Core MVC</span>
                <span className="skill-tag">React</span>
                <span className="skill-tag">Node.js</span>
                <span className="skill-tag">Express.js</span>
              </div>
            </div>
            <div className="skill-category">
              <h3>Databases & Tools</h3>
              <div className="skill-tags">
                <span className="skill-tag">SQL Server</span>
                <span className="skill-tag">MongoDB</span>
                <span className="skill-tag">Postman</span>
                <span className="skill-tag">Azure DevOps</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Want to discuss what I could bring to your team?</h2>
            <p>Let's Talk!</p>
            <div className="contact-info">
              <div className="contact-item">
                <strong>Email:</strong>
                <a href="mailto:JacobW@segotw.com">JacobW@segotw.com</a>
              </div>
              <div className="contact-item">
                <strong>Phone:</strong>
                <a href="tel:+13149399335">+1 (314) 939-9335</a>
              </div>
            </div>
            <div className="cta-buttons">
              <Link to="/about" className="btn btn-primary">
                Learn More About Me
              </Link>
              <Link to="/experience" className="btn btn-secondary">
                View Experience
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 